import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { mangaList } from "@/mocks/manga";

export default function Categories() {
  return (
    <section id="categories" className="mx-auto w-full max-w-[1400px] px-4 py-14 md:py-20">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-grid-fill"></i>
            热门栏目
          </span>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">按心情挑一部</h2>
          <p className="mt-2 max-w-xl text-[15px] text-foreground-600">
            纯爱甜宠到冤家拉扯，六大恋爱剧情栏目，想嗑哪种CP都有对味的作品。
          </p>
        </div>
        <span className="text-sm text-foreground-500">共 {categories.length} 个栏目 · {mangaList.length} 部作品</span>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = mangaList.filter((m) => m.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group relative overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden">
                <img
                  src={cat.cover}
                  alt={`${cat.name}恋爱漫画栏目`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/10 to-transparent"></div>
                <span className="absolute left-4 top-3 rounded-full px-2.5 py-1 text-[11px] font-medium text-background-50" style={{ backgroundColor: cat.accent }}>
                  {count} 部作品
                </span>
                <span className="absolute inset-x-4 bottom-4 text-background-50">
                  <span className="block font-display text-2xl">{cat.name}</span>
                  <span className="mt-1 block text-sm text-background-100/90">{cat.tagline}</span>
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 p-4">
                <p className="line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-all group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}